import gql from 'graphql-tag'

export default gql`
	query listLoyaltyCardItems($filter: filterLoyaltyCarItems) {
		cashAssist {
			listLoyaltyCardItems(filter: $filter) {
				total
				hasNextPage
				items {
					dateTime
					name
					groupId
					cashRegister {
						id
						name
					}
					billNumber
					userName
					increase
					decrease
					balance
					group {
						id
						name
					}
					points
					pointsTotal
					mode
					transactionDate
					isCancelled
				}
			}
		}
	}
`
